var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "32px",
    viewBox: "0 0 27 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Word") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.231,0 L25.263,6.336 L25.2631579,27.45408 C25.2631579,28.8601528 24.1233107,30 22.7172379,30 L2.54592,30 C1.13984721,30 6.16283464e-16,28.8601528 0,27.45408 L0,2.54592 C-1.72194254e-16,1.13984721 1.13984721,2.58291381e-16 2.54592,0 L19.231,0 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Word",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u77E9\\u5F62",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#3D89F4",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#ACCCF7",
    mask: "url(#mask-2)",
    x: 18.9473684,
    y: -5.17241379,
    width: 9.47368421,
    height: 11.3793103,
    rx: 1.27296
  })), /*#__PURE__*/React.createElement("g", {
    id: "word",
    transform: "translate(5.355717, 10.428571)",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    points: "5.51724138 11.4285714 3.19419237 11.4285714 0.580762245 0.571428566 2.90381126 0.571428566"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    points: "3.4047187 11.4285714 5.7277677 11.4285714 8.34119782 0.571428566 6.01814883 0.571428566"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    points: "12.2758621 11.4285714 9.95281307 11.4285714 7.33938294 0.571428566 9.66243194 0.571428566"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    points: "10.1633394 11.4285714 12.4863884 11.4285714 15.0998185 0.571428566 12.7767695 0.571428566"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWord);
export default __webpack_public_path__ + "static/media/word.c26f4f1b020aec507ec69624d1d04158.svg";
export { ForwardRef as ReactComponent };